var obj = {
    index: function() {
        this.preloading(); // 预加载
        // this.indexSwiper();         // 首页大轮播
        this.floatCode(); // 游戏下载浮窗
        this.indexBind(); // 首页按钮
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;

        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.loding_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.index').addClass('index-show');
            this.indexSwiper();
            setTimeout(function() {
                $('.top-clouds').addClass('top-clouds-ani');
                $('.bg').addClass('bg-ani');
            }, 500)
            setTimeout(function() { $('.top-clouds').remove() }, 3000)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '//static.qcplay.com/snail/csbwg/images/pc/m_dt_sz.png',
            '//static.qcplay.com/snail/csbwg/images/pc/m_dt_t.png',
            '//static.qcplay.com/snail/csbwg/images/pc/m_jdt.png',
            '//static.qcplay.com/snail/csbwg/images/pc/ani_bg/circular.png',
            '//static.qcplay.com/snail/csbwg/images/pc/ani_bg/yun_01.png',
            '//static.qcplay.com/snail/csbwg/images/pc/ani_bg/yun_02.png',
            '//static.qcplay.com/snail/csbwg/images/pc/ani_bg/yun_03.png',
            '//static.qcplay.com/snail/csbwg/images/pc/ani_bg/yun_04.png',
            '//static.qcplay.com/snail/csbwg/images/pc/ani_bg/yun_05.png',
            '//static.qcplay.com/snail/csbwg/images/pc/ani_bg/yun_06.png',
            '//static.qcplay.com/snail/csbwg/images/pc/ani_bg/zhuzi.png',
            '//static.qcplay.com/snail/csbwg/images/pc/ani_bg/cultural_relic_01.png',
            '//static.qcplay.com/snail/csbwg/images/pc/ani_bg/cultural_relic_02.png',
            '//static.qcplay.com/snail/csbwg/images/pc/ani_bg/cultural_relic_03.png',
            '//static.qcplay.com/snail/csbwg/images/pc/ani_bg/cultural_relic_04.png',
            '//static.qcplay.com/snail/csbwg/images/pc/ani_bg/cultural_relic_05.png',
            '//static.qcplay.com/snail/csbwg/images/pc/ani_bg/shine2.png',
            '//static.qcplay.com/snail/csbwg/images/pc/ani_bg/shine.png',
            '//static.qcplay.com/snail/csbwg/images/pc/title_img.png',
            '//static.qcplay.com/snail/csbwg/images/pc/logo_img.png',
            '//static.qcplay.com/snail/csbwg/images/pc/snail.png',
            '//static.qcplay.com/snail/csbwg/images/pc/title_img.png',
            '//static.qcplay.com/snail/csbwg/images/pc/title_img.png',
            '//static.qcplay.com/snail/csbwg/images/pc/title_img.png',
            '//static.qcplay.com/snail/csbwg/images/pc/title_img.png',
            '//static.qcplay.com/snail/csbwg/images/pc/title_img.png',
            '//static.qcplay.com/snail/csbwg/images/pc/index_bg.jpg',
            '//static.qcplay.com/snail/csbwg/images/pc/index_bg_02.jpg',
            '//static.qcplay.com/snail/csbwg/images/pc/clouds_r.png',
            '//static.qcplay.com/snail/csbwg/images/pc/clouds_l.png'
        ]);
    },
    // 全屏滚动判断
    scroll: function() {
        $(window).scroll(function() {
            var scrollTop = $(this).scrollTop();
            var scrollHeight = $(document).height();
            var windowHeight = $(this).height();
            $(document).scrollTop() > 400 ? $('.return-top').fadeIn() : $('.return-top').fadeOut();
        });

        $('.return-top').click(function(event) {
            $(document).scrollTop(0);
        });
    },
    // 首页轮播
    indexSwiper: function() {
        var mySwiper = new Swiper('.swiper-container', {
            pagination: '.swiper-pagination',
            direction: 'vertical',
            slidesPerView: 'auto',
            paginationClickable: true,
            spaceBetween: 0,
            mousewheelControl: true,
            resistanceRatio: 0,
            onInit: function(swiper) {
                swiperAnimate(swiper);
            },
            onSlideChangeEnd: function(swiper) {
                swiperAnimate(swiper);
            },
        });

        function tabSwiperTwo(swiperClass, swiperPagin) {
            var swiper3 = new Swiper(swiperClass, {
                pagination: swiperPagin,
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                paginationClickable: true,
                spaceBetween: 50,
                speed: 300,
                loop: true,
                onInit: function(swiper) {
                    swiperAnimate(swiper);
                },
                onSlideChangeEnd: function(swiper) {
                    swiperAnimate(swiper);
                },
                onTouchEnd: function(swiper) {
                    swiperAnimate(swiper);
                },
            });
        }
        var swiperX1 = tabSwiperTwo('.swiper-container2', '.swiper-pagination');
        var swiperX2 = tabSwiperTwo('.swiper-container3', '.swiper-pagination-02');
        var dataNum = null;
        $('.swiper-container3 .slide-01 .act-box').on('click', function(event) {
            dataNum = $(this).attr('data');
            $('.act-dec-popup').fadeIn().addClass('act-dec-0' + dataNum + '');
        });
        $('.year_box').on('click', function(event) {
            $('.year_pop').fadeIn();
        });
        $('.close-btn').click(function(event) {
            $('.act-dec-popup').fadeOut().removeClass('act-dec-0' + dataNum + '');
            $('.year_pop').fadeOut();
        });
    },
    // 游戏下载浮窗
    floatCode: function() {

        // 下载链接
        $('.btn-box').on('click', 'a', function() {
            var className = $(this).attr('class');
            // console.log(className)
            var game_id = 39;
            $.ajax({
                type: "get",
                url: 'https://api.qingcigame.com/get_url?game_id=' + game_id + '',
                dataType: 'json',
                success: function(json) {
                    if (className.indexOf('app-btn') !== -1) {
                        // ios
                        if (json.data.ios_down_url == '') {
                            layer.msg('ios下载暂未开放，敬请期待！<br/>详情请关注官方qq群：666341871', { time: 3000 });
                        } else {
                            location.href = json.data.ios_down_url
                        }
                    } else {
                        // 安卓
                        if (json.data.android_download_url == '') {
                            layer.msg('安卓下载暂未开放，敬请期待！<br/>详情请关注官方qq群：666341871', { time: 3000 });
                        } else {
                            location.href = json.data.android_down_url
                        }
                    }
                }
            })
        });

        // var iosUrl = 'https://apps.apple.com/cn/app/id1507966188';
        // var andUrl = 'http://download2.qcplay.com/snail/apk/snail_qc_official_0.1.40.apk'; 

        // $('.float-code .app-btn').attr('href', iosUrl);
        // $('.float-code .and-btn').attr('href', andUrl);

        // 点击左侧二维码浮窗
        $('.float-code .changes-btn').on('click', 'a', function(event) {
            !$('.float-code').hasClass('select') ? $('.float-code').addClass('select') : $('.float-code').removeClass('select');
        });
        $('.float-code').addClass('select');

        // var index = layer.load(2, {shade: [0.1, '#fff']});
        // $.ajax({
        //     url: "https://api.qingcigame.com/web/configInfo",
        //     type: "GET",
        //     xhrFields: {
        //         withCredentials: true
        //     },
        //     success: function(json) {
        //         if(json.code == 200) {
        //             // QQ:
        //             $.each(json.data.list.QQ, function(index, values) {
        //                 var mengxinHtml = '<li><p>'+values+'</p></li>';
        //                 $('.right-QQ ul').append(mengxinHtml);
        //             });
        //             // 公众号
        //             $('.hidden-code-box .code-gzh img').attr('src', json.data.official_account_image);
        //             // 微博
        //             $('.hidden-code-box .code-gfwb img').attr('src', json.data.micro_blog);
        //             // b博
        //             $('.hidden-code-box .code-gfbb img').attr('src', json.data.b_blog);
        //             // 逗音
        //             $('.hidden-code-box .code-gfdy img').attr('src', json.data.tiktok);
        //             // 客服
        //             $('.hidden-service-box .code-img img').attr('src', json.data.customer_service_image);
        //             // 公众号：
        //             $('.hidden-service-box .gzh').html(json.data.official_account);
        //             // 邮箱
        //             $('.hidden-service-box .email').html(json.data.email);
        //             layer.close(index);
        //         }else {
        //             layer.msg("服务器请求失败", {time: 2000});
        //             layer.close(index);
        //         }
        //     },error: function() {
        //         layer.msg("服务器请求失败", {time: 2000});
        //         layer.close(index);
        //     }
        // })

        $('.nav-link-off-02').click(function(event) {
            layer.msg("暂未开放，敬请期待!", { time: 2000 });
        });
    },

    indexBind: function() {
        $('#share-2').share({ sites: ['qzone', 'qq', 'weibo', 'wechat'] });

        $.ajax({
            url: "https://api.qingcigame.com/snail/pay/number?id=9",
            type: "POST",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    $('.number-data').html(json.data.number);
                } else {
                    layer.msg("服务器请求失败", { time: 2000 });
                }
            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
                layer.close(index);
            }
        })
    }
}